<template>
  <div class="chart-container">
    <Bar
      :data="chartData"
      :options="chartOptions"
      :redraw="true"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Bar } from 'vue-chartjs'
import {
  Chart, BarElement, CategoryScale, LinearScale,
  Title, Tooltip, Legend
} from 'chart.js'

Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend)

const props = defineProps({
  dataInicio: String,
  dataFim:    String
})

const chartData = ref({ labels: [], datasets: [] })

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: 'Prospecções vs Matrículas (Mensal)',
      align: 'start'
    },
    tooltip: {
      mode: 'index', intersect: false,
      callbacks: {
        // footer(ctxs) {
        //   const totals = ctxs.map(c => c.parsed.y).reduce((s,v)=>s+v,0)
        //   return `Total: ${totals}`
        // }
      },
      footerFont: { weight: 'bold' }
    },
    legend: { position: 'top' }
  },
  scales: {
    x: { stacked: false },
    y: { beginAtZero: true }
  }
}

async function fetchData() {
  try {
    const { data: resp } = await axios.get(
      '/gestao/graficos/individuais/prospeccao-mensal',
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )
    chartData.value = {
      labels: resp.labels,
      datasets: [
        {
          label: 'Total de Prospecções',
          data: resp.series['Prospecções'],
          backgroundColor: '#F1948A'
        },
        {
          label: 'Matrículas',
          data: resp.series['Matrículas'],
          backgroundColor: '#1ABC9C'
        }
      ]
    }
  } catch (e) {
    console.error('Erro em ProspeccaoMatricChart:', e)
  }
}

onMounted(fetchData)
watch(() => [props.dataInicio, props.dataFim], fetchData)
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 300px;
}
@media(min-width:768px){
  .chart-container { height: 400px; }
}
</style>
